export const DATE_FORMAT_TIME = 'YYYY-MM-DD HH:mm:ss';

export const PANGU_IDS = {
  development: 1240,
  production: 1241,
};

export const CURRENT_MAINTAINER = 'jiangyinsu';

// 本地缓存上一次的登录类型，控制进入wx、rtx、psw登录界面
export const LOGIN_TYPE = {
  wx: 'wx',
  rtx: 'rtx',
  psw: 'psw',
};

export const PAGE_NAME_MAP = {
  myTasks: 'myTasks',
  checkTasks: 'checkTasks',
  checkedTasks: 'checkedTasks',
  reviewTasks: 'reviewTasks',
  projectList: 'projectList',
  samplingTasks: 'samplingTasks',
  iframe: 'iframe',
  botsList: 'botsList',
  noAuth: 'noAuth',
};

export const USER_AUTH_MAP = {
  admin: 1,
  external: 2,
};

export const IS_VERIFY_TYPE = {
  unValid: 0,
  isValid: 1,
  isNoAuth: 2,
  isExpired: 4,
};
